import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    boxShadow: 'none',
    border: '1px solid #DBDCDD',
    boxSizing: 'border-box',
    borderRadius: '10px',
    padding: '26px 24px 24px 24px',
  },
}))

export const LocationCard = ({
  title,
  buttonText,
  onClick,
  secondButtonText,
  secondOnClick,
  children,
  url,
  secondUrl,
  subtitle,
}) => {
  const classes = useStyles()
  return (
    <Card className={classes.card}>
      <Typography variant="h3" color="textSecondary" style={{ opacity: 0.65 }}>
        {title}
      </Typography>
      {subtitle && (
        <Box pb="12px">
          <Typography variant="h2" color="textSecondary">
            {subtitle}
          </Typography>
        </Box>
      )}
      {children}
      {(buttonText || secondButtonText) && (
        <CardActions>
          <Box width={1} mt={3}>
            {secondButtonText && (
              <Box mb={2}>
                <Button
                  component={Link}
                  href={secondUrl}
                  fullWidth
                  onClick={secondOnClick}
                  variant="outlined"
                  color="secondary"
                >
                  {secondButtonText}
                </Button>
              </Box>
            )}
            {buttonText && (
              <Button
                component={Link}
                href={url}
                fullWidth
                onClick={onClick}
                variant="outlined"
                color="secondary"
              >
                {buttonText}
              </Button>
            )}
          </Box>
        </CardActions>
      )}
    </Card>
  )
}

LocationCard.propTypes = {
  title: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  secondButtonText: PropTypes.string,
  secondOnClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  url: PropTypes.string,
  secondUrl: PropTypes.string,
  subtitle: PropTypes.string,
}
